import {MeetingCommentFile} from './MeetingCommentFile'
import NewMeetingComment from './NewMeetingComment'
import {InputError} from '../components/AdminMeetingCommentInputForm'
import {SubmitCommentAndFilesTemplateForAdmin} from './SubmitCommentAndFilesTemplateForAdmin'
import {MeetingRepositoryForAdmin} from '../MeetingRepositoryForAdmin'
import {AsyncCallFunctionType, AsyncFunction} from '../../shared/hoc/withAsyncCommunication'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import {FileDataForValidate} from './FileDataForValidate'
import {Nullable} from '../../../app/TypeHelpers'

interface SendData {
    condominiumCd: string
    meetingId: number
    newMeetingComment: NewMeetingComment
}

export class SubmitNewCommentProcedureForAdmin extends SubmitCommentAndFilesTemplateForAdmin<SendData> {
    meetingRepoForAdmin: MeetingRepositoryForAdmin

    constructor(
        registerCommentError: (inputError: InputError) => void,
        meetingRepositoryForAdmin: MeetingRepositoryForAdmin,
        asyncCallFunction: AsyncCallFunctionType,
        eventEmitter: EventEmitterExAdmin,
    ) {
        super(registerCommentError, asyncCallFunction, eventEmitter)
        this.meetingRepoForAdmin = meetingRepositoryForAdmin
    }

    registerCommentFunction(sendData: SendData): AsyncFunction<any, number> {
        return () => this.meetingRepoForAdmin.registerComment(
            sendData.condominiumCd,
            sendData.meetingId,
            sendData.newMeetingComment,
        )
    }

    validateFileFunction(fileDataForValidate: FileDataForValidate): AsyncFunction<any, void> {
        return () => this.meetingRepoForAdmin.validateParallelFileUpload(fileDataForValidate)
    }

    async registerFile(sendData: SendData, commentId: number, commentFile: MeetingCommentFile): Promise<void> {
        // NatAsyncCallFunctionによる標準の通信エラー処理を行わない
        // 原因はなんであれファイルを再登録する必要があることをユーザーに伝える必要があるため、全ての例外を捕捉する
        await this.meetingRepoForAdmin.registerCommentFile(
            sendData.condominiumCd,
            sendData.meetingId,
            commentId,
            commentFile,
        )
    }

    async submit(
        condominiumCd: string,
        meetingId: number,
        newMeetingComment: NewMeetingComment,
        commentFileList: MeetingCommentFile[],
    ): Promise<Nullable<number>> {
        this.commentId = null
        await this.process(
            {
                condominiumCd: condominiumCd,
                meetingId: meetingId,
                newMeetingComment: newMeetingComment,
            },
            commentFileList,
        )

        return this.commentId
    }
}
